import { getImageData } from '~/texContent'
import { QUIZ_SUBJECT } from '~/types/homebaseQuiz.types'
import { TopicOverview } from '~/types/theory'

export function getIconName(key: string): { src: string; alt: string } {
  const data = getImageData(key)
  return { src: data?.icon?.src || '', alt: data?.icon?.alt || '' }
}

const classNameData = [
  {
    keyMatchers: ['number', 'tall', 'chysla-ta-velychyny'],
    color: 'text-theory-red',
    backgroundColor: 'bg-theory-red-light',
  },
  {
    keyMatchers: ['algebra', 'alhebra'],
    color: 'text-theory-pink',
    backgroundColor: 'bg-theory-pink-light',
  },
  {
    keyMatchers: ['geometry', 'geometri', 'heometriya'],
    color: 'text-theory-magenta',
    backgroundColor: 'bg-theory-magenta-light',
  },
  {
    keyMatchers: ['statistics', 'statistikk', 'statystyka'],
    color: 'text-theory-purple',
    backgroundColor: 'bg-theory-purple-light',
  },
  {
    keyMatchers: ['functions', 'funksjoner', 'funktsiyi'],
    color: 'text-theory-blue-slate',
    backgroundColor: 'bg-theory-blue-slate-light',
  },
  {
    keyMatchers: ['proofs', 'bevis', 'dovedennya'],
    color: 'text-theory-blue-crayola',
    backgroundColor: 'bg-theory-blue-crayola-light',
  },
  {
    keyMatchers: [
      'eksamen',
      'exam',
      'economy',
      'økonomi',
      'okonomi',
      'ohlyad-i-porady-shchodo-skladannya-ispytu',
      'osobysti-finansy',
    ],
    color: 'text-theory-orange',
    backgroundColor: 'bg-theory-orange-light',
  },
]

export function getTopicClassName(chapter: TopicOverview, classTypes?: 'only-text'): string {
  const res = classNameData.find((data) =>
    data.keyMatchers.some((matcher) => {
      const chapterName = chapter.path.split('/')[2]
      return chapterName?.toLowerCase().includes(matcher)
    }),
  )

  if (!res) return ''

  if (classTypes === 'only-text') {
    return res.color
  } else {
    return `${res.color} ${res.backgroundColor}`
  }
}

export function getMultipleChoiceThreshold(eventId: string): number {
  switch (eventId) {
    case QUIZ_SUBJECT.THE_MULTIPLICATION_TABLE:
      return 5
    case QUIZ_SUBJECT.FRACTIONS:
      return 6
    case QUIZ_SUBJECT.PERCENT:
      return 5
    case QUIZ_SUBJECT.POWERS:
      return 9
    case QUIZ_SUBJECT.BASIC_ALGEBRA:
      return 5
    case QUIZ_SUBJECT.PARENTHESES:
      return 2
    case QUIZ_SUBJECT.FACTORIZATION:
      return 1
    case QUIZ_SUBJECT.EQUATIONS:
      return 9
    case QUIZ_SUBJECT.FUNCTIONS:
      return 6
    default:
      return 0
  }
}
export function childrenIsTexContent(topic: TopicOverview[]): boolean {
  return Boolean(topic?.every((child) => !('children' in child)))
}
